<common-card>
  <common-card-header>
    <h5>
      <span *ngIf="!withholding; else updateWithholding">
        {{'modules.valet.valet_profile.withholding_dialog.create_title' | translate}}
      </span>
      <ng-template #updateWithholding>
        {{'modules.valet.valet_profile.withholding_dialog.update_title' | translate}}
      </ng-template>
    </h5>
  </common-card-header>
  <common-card-body [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="label required" for="name">
            {{'modules.valet.valet_profile.withholding_dialog.name' | translate}}
          </label>
          <input id="name"
                 type="text"
                 nbInput
                 fullWidth
                 formControlName="name">
          <slnk-shared-input-validator>
            <slnk-shared-input-validator-item
              [validationFormControl]="form.controls['name']"
              [validation]="'required'">
            </slnk-shared-input-validator-item>
          </slnk-shared-input-validator>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="label required" for="totalAmount">
            {{'modules.valet.valet_profile.withholding_dialog.total_amount' | translate}}
          </label>
          <input id="totalAmount"
                 type="number"
                 nbInput
                 fullWidth
                 formControlName="totalAmount">
          <slnk-shared-input-validator>
            <slnk-shared-input-validator-item
              [validationFormControl]="form.controls['totalAmount']"
              [validation]="'required'">
            </slnk-shared-input-validator-item>
          </slnk-shared-input-validator>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="label required" for="totalInstallments">
            {{'modules.valet.valet_profile.withholding_dialog.total_installments' | translate}}
          </label>
          <input id="totalInstallments"
                 type="number"
                 nbInput
                 fullWidth
                 formControlName="totalInstallments">
          <slnk-shared-input-validator>
            <slnk-shared-input-validator-item
              [validationFormControl]="form.controls['totalInstallments']"
              [validation]="'required'">
            </slnk-shared-input-validator-item>
          </slnk-shared-input-validator>
        </div>
      </div>
      <div class="col-6" *ngIf="form.controls['remainingAmount']">
        <div class="form-group">
          <label class="label required" for="remainingAmount">
            {{'modules.valet.valet_profile.withholding_dialog.remaining_amount' | translate}}
          </label>
          <input id="remainingAmount"
                 type="number"
                 nbInput
                 fullWidth
                 formControlName="remainingAmount">
          <slnk-shared-input-validator>
            <slnk-shared-input-validator-item
              [validationFormControl]="form.controls['remainingAmount']"
              [validation]="'required'">
            </slnk-shared-input-validator-item>
          </slnk-shared-input-validator>
        </div>
      </div>
      <div class="col-6" *ngIf="form.controls['remainingInstallments']">
        <div class="form-group">
          <label class="label required" for="remainingInstallments">
            {{'modules.valet.valet_profile.withholding_dialog.remaining_installments' | translate}}
          </label>
          <input id="remainingInstallments"
                 type="number"
                 nbInput
                 fullWidth
                 formControlName="remainingInstallments">
          <slnk-shared-input-validator>
            <slnk-shared-input-validator-item
              [validationFormControl]="form.controls['remainingInstallments']"
              [validation]="'required'">
            </slnk-shared-input-validator-item>
          </slnk-shared-input-validator>
        </div>
      </div>
      <div class="col-6" *ngIf="form.controls['allowInExpenses']">
        <div class="form-group">
          <nb-checkbox id="allowInExpenses"
                       formControlName="allowInExpenses">
            {{'modules.valet.valet_profile.withholding_dialog.allow_in_expenses' | translate}}
          </nb-checkbox>
        </div>
      </div>
    </div>
  </common-card-body>
  <common-card-footer>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button nbButton (click)="cancel()">
          {{'global.buttons.cancel' | translate}}
        </button>
      </div>
      <div class="col-auto">
        <button nbButton
                status="primary"
                [disabled]="!form.valid"
                (click)="submit()">
          {{'global.buttons.submit' | translate}}
        </button>
      </div>
    </div>
  </common-card-footer>
</common-card>

